<script>
    import {GET, POST} from "../components/communication.js";
    import {authToken, sessionStorageSet, sessionStorageRemove, flashErrorMessage, flashSuccessMessage, flashError}
        from "../components/stores.js";
    import {navigate} from "svelte-routing";
    import {validateEmail} from "../components/utils.js";

    export let short = false;
    export let vinkkiUrl = "toiminnallinen_opas";
    let title = "Toiminnallisen harjoittelun opas";
    let titlePic = "/svelte-site/img/treenivinkit/leka.jpg";
    let firstPara = "Lataa tästä itsellesi pieni toiminnallisen harjoittelun opas ja esimerkkitreeni.";

    let sub = {firstName: null, lastName: null, email: null, notarobot: null};
    let disabled = true;

    async function subToiminnallisenHarjoituksenOpas(event) {
        if (!disabled) {
            const response = POST("/C/subscribeToFunctionalTraining", JSON.stringify(sub));
            const data = await response;
            if (data && data.error === undefined) {
                flashSuccessMessage.set("Toiminnallisen harjoittelun opas on matkalla. Tsekkaa mailit.");
                sub.email = "";
                sub.lastName = "";
                sub.firstName = "";
            } else if(data && data.error !== undefined) {
                flashErrorMessage.set(data.error);
            } else {
                flashErrorMessage.set("Jotain meni pieleen. Kokeile uudestaan hetken päästä.");
            }
        }
    }

    // reCaptcha vaatii globaalin callback funkkarin
    //window.subToiminnallisenHarjoituksenOpas = sF;

    function validateNotArobot(value) {
        if(value === "yksitoista" || value === "Yksitoista" || value === "11") {
            return true;
        } else {
            return false;
        }
    }

    let disabledClass = "disabled";
    function enableButtons(c) {
        disabled =
            !c.firstName ||
            !c.lastName ||
            !c.email ||
            !validateNotArobot(c.notarobot) ||
        !validateEmail(c.email);

        if (disabled) {
            disabledClass = "disabled";
        } else {
            disabledClass = "";
        }
    }
</script>

<!--  oppaat -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}

    <a href="/treenivinkit/{vinkkiUrl}" class="blogSummary">
        <span class="articleImage" style="background-image: url('{titlePic}')"></span>
        <span>
        <span class="blogTitle">{title}</span>
        <span class="blogDate">17.3.2023</span>
        <span class="blogShortContent">{firstPara}</span>
    </span>
    </a>

{:else}
    <div class="page">
        <article class="container">


            <div style="background-size: cover; background-position: center; background-image: url('{titlePic}')">
                <h1 style="padding:3em 0; text-align:center; font-weight:700; color: #fff;">{title}</h1>
            </div>
            <!-- <img src="/svelte-site/img/treenivinkit/kelkka.jpg" alt="kelkka" style="max-width:400px"> -->
            <p>{firstPara}</p>
            <h2>Lataa alta maksuton toiminnallisen harjoittelun opas ja toiminnallinen treeni käyttöösi!</h2>


            <p>Oletko kokeillut maustaa omaa treeniäsi toiminnallisen treenin liikkeillä ja välineillä?
                Toiminnallinen treeni on samalla sekä tehokasta että hauska tapa treenata. Lataa tästä
                maksuton opas josta opit lisää toiminnallisesta treenistä sekä pääset kokeilemaan
                helpoa, aloittelijalle soveltuvaa koko kehon treeniä.</p>

            <p>Lataamalla oppaan liityt samalla Dynamosalin ilmaiselle uutiskirjelistalle.
                Lähetämme postia n. kerran kuukaudessa. Voit halutessasi poistua listalta koska tahansa.</p>
            <p><a href="rekisteriseloste">Tietosuojaseloste</a></p>
            <div class="card">
                <h5 class="card-header">Tarvitsemme nimesi ja sähköpostiosoitteesi lähettääksemme oppaan</h5>
                <div class="card-body">
                    <form>
                        <div class="form-group">
                            <label for="firstName">Etunimi</label>
                            <input class="form-control" required type="text" id="firstName" placeholder=""
                                   bind:value={sub.firstName} on:keyup={enableButtons(sub)}/>
                        </div>
                        <div class="form-group">
                            <label for="lastName">Sukunimi</label>
                            <input class="form-control" required type="text" id="lastName" placeholder=""
                                   bind:value={sub.lastName} on:keyup={enableButtons(sub)}/>
                        </div>
                        <div class="form-group">
                            <label for="email">Sähköposti</label>
                            <input class="form-control" required type="email" id="email"
                                   placeholder=""
                                   bind:value={sub.email} on:keyup={enableButtons(sub)}/>
                        </div>

                        <div class="form-group">
                            <label for="notarobot">Robottivarmistus - Kirjoita tekstinä: Palijoko on yhtä vaille
                                tusina?</label>
                            <input class="form-control" required type="text" id="notarobot" placeholder=""
                                   bind:value={sub.notarobot} on:keyup={enableButtons(sub)}/>
                        </div>
                        <button
                                on:click|preventDefault={subToiminnallisenHarjoituksenOpas}
                                type="button" class="btn btn-primary {disabledClass}" {disabled}>Lataa opas</button>
                    </form>
                </div>
            </div>
        </article>
    </div>
{/if}
